import Dialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ReactNode } from 'react';
import { Cross } from './icons';

export interface ModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  actions?: ReactNode;
  maxWidth?: MuiDialogProps['maxWidth'];
}

export function Modal({ open, title, onClose, children, actions, maxWidth = 'sm' }: ModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      // borderRadius comes from the theme's MuiDialog.paper override (8px,
      // ported from ComplyControl's adminPanelTheme.ts) — Figma modal, node
      // 4036:85796.
      PaperProps={{ sx: { p: 1 } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, pt: 3 }}>
        <Typography variant="h3">{title}</Typography>
        <IconButton onClick={onClose} aria-label="close">
          <Cross sx={{ width: 16, height: 16, color: '#97A2AA' }} />
        </IconButton>
      </Box>
      <DialogContent>{children}</DialogContent>
      {actions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, px: 3, pb: 3 }}>
          {actions}
        </Box>
      )}
    </Dialog>
  );
}
